import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoCotaDistribUnidade({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'visuacotadistribunidade', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoCotaDistribUnidade({ payload }) {
  try {
    const { orga_codigo, unid_codigo, params } = payload;

    yield call(api.delete, `visuacotadistribunidade/${orga_codigo}/${unid_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaocotadistribunidade, params } = payload;

    yield call(
      api.post,
      'visuacotadistribunidade',
      operacaocotadistribunidade
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/visuacotadistribunidade');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { orga_codigo, unid_codigo } = payload;

    const { data } = yield call(
      api.get,
      `visuacotadistribunidade/${orga_codigo}/${unid_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaocotadistribunidade, params } = payload;

    yield call(
      api.put,
      'visuacotadistribunidade',
      operacaocotadistribunidade
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/visuacotadistribunidade');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'visuacotadistribunidade', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaocotadistribunidade/VISUACOTADISTRIBUNIDADE_IN_REQUEST',
    requestOperacaoCotaDistribUnidade
  ),
  takeLatest(
    '@operacaocotadistribunidade/DELETE_VISUACOTADISTRIBUNIDADE',
    deleteOperacaoCotaDistribUnidade
  ),
  takeLatest(
    '@operacaocotadistribunidade/SUCCESS_REMOVE',
    requestOperacaoCotaDistribUnidade
  ),
  takeLatest(
    '@operacaocotadistribunidade/STORE_VISUACOTADISTRIBUNIDADE',
    store
  ),
  takeLatest(
    '@operacaocotadistribunidade/FIND_VISUACOTADISTRIBUNIDADE',
    find
  ),
  takeLatest(
    '@operacaocotadistribunidade/UPDATE_VISUACOTADISTRIBUNIDADE',
    update
  ),
  takeLatest(
    '@operacaocotadistribunidade/RECORD_FILTERING',
    applyedFilters
  ),
]);
